import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';

export const root = {};

export const id = {
  [HTTP_METHODS.DELETE]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/uploaders/@id`,
    params: {} as { id: string },
    method: HTTP_METHODS.DELETE,
  },
};
